
import { AIEvent, AppConfig } from "../types";

let accessToken: string | null = null;

export const googleSheetsService = {
  setToken(token: string) {
    accessToken = token;
  },

  isConnected(): boolean {
    return !!accessToken;
  },

  async fetchSheetData(config: AppConfig): Promise<AIEvent[]> {
    if (!accessToken) return [];
    try {
      const response = await fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${config.sheetId}/values/${config.tabName}!A2:L`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (!response.ok) {
        const err = await response.json().catch(() => ({ error: { message: response.statusText } }));
        throw new Error(err.error?.message || `Failed to fetch sheet data (Status ${response.status})`);
      }
      const data = await response.json();
      return (data.values || []).map((row: any[], index: number) => ({
        id: `sheet-${index + 2}`, 
        campaignName: row[0] || "",
        category: row[1] || "",
        url: row[2] || "",
        priority: row[3] || "",
        year: parseInt(row[4]) || 0,
        month: parseInt(row[5]) || 0,
        startDate: row[6] || "",
        endDate: row[7] || "",
        location: row[8] || "",
        focusArea: row[9] || "",
        information: row[10] || "",
        addedAt: row[11] || ""
      }));
    } catch (err: any) {
      console.error("Google Sheets Fetch Error:", err);
      if (err instanceof TypeError || err.message === 'Failed to fetch') {
        throw new Error("Network Error: Unable to reach Google Sheets. Check your connection.");
      }
      throw err;
    }
  },

  async appendEvent(config: AppConfig, event: AIEvent) {
    if (!accessToken) throw new Error("Not authenticated with Google");
    try {
      const row = [event.campaignName, event.category, event.url, event.priority, event.year, event.month, event.startDate, event.endDate, event.location, event.focusArea, event.information, event.addedAt];
      const response = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${config.sheetId}/values/${config.tabName}!A1:append?valueInputOption=USER_ENTERED`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ values: [row] })
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({ error: { message: response.statusText } }));
        throw new Error(err.error?.message || `Failed to append row (Status ${response.status})`);
      }
      await this.sortSheetByDate(config);
    } catch (err: any) {
      if (err instanceof TypeError || err.message === 'Failed to fetch') {
        throw new Error("Network Error: Unable to append to Google Sheets. Check your connection.");
      }
      throw err;
    }
  },

  async sortSheetByDate(config: AppConfig) {
    if (!accessToken) return;
    try {
      const metaRes = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${config.sheetId}?fields=sheets.properties`, { headers: { Authorization: `Bearer ${accessToken}` } });
      const meta = await metaRes.json();
      const internalId = meta.sheets.find((s: any) => s.properties.title === config.tabName)?.properties.sheetId || 0;
      await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${config.sheetId}:batchUpdate`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ requests: [{ sortRange: { range: { sheetId: internalId, startRowIndex: 1, startColumnIndex: 0, endColumnIndex: 12 }, sortSpecs: [{ dimensionIndex: 6, sortOrder: "ASCENDING" }] } }] })
      });
    } catch (e) {}
  }
};
